import { Navigate, Route, Routes, useParams } from 'react-router-dom';
import { CategoryMetrics } from './CategoryMetrics/CategoryMetrics';
import { SubMetricDetail } from './SubMetricDetail/SubMetricDetail';

export const InsightsRoutes = () => {
  const { kitId } = useParams<{ kitId: string }>();

  return (
    <Routes>
      <Route
        path={`:category/:subMetricId`}
        element={<SubMetricDetail key='insights-submetric-detail' />}
      />
      {/* Old links in emails, PDF reports and bookmarks still point here */}
      <Route
        path={`/all-insights`}
        element={
          <Navigate to={`/results/${kitId}/metrics/all-metrics`} replace />
        }
      />
      <Route
        path={`:category`}
        element={<CategoryMetrics key='insights-category-metrics' />}
      />
      <Route
        path={``}
        key='insights'
        element={<Navigate to={`/results/${kitId}`} replace />}
      />
    </Routes>
  );
};
